import { render, staticRenderFns } from "./PhysicalStorage.vue?vue&type=template&id=11aab34a"
import script from "./PhysicalStorage.vue?vue&type=script&lang=js"
export * from "./PhysicalStorage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports